import {
  HIT_POINTS,
  STRESS,
  EVASION,
  LOADOUT,
  VAULT,
  PROFICIENCY,
  DOMAIN_CARD,
} from '../../character/content/templates';

export default function LevelingUp() {
  return (
    <>
      <p>Your party levels up whenever the GM decides you've reached a narrative milestone (usually about every 3 sessions). All party members level up at the same time.</p>
      <p>Daggerheart has 10 PC levels divided into 4 tiers:</p>

      <p className="rule-note">
        <ul>
          <li>Tier 1 encompasses level 1 only.</li>
          <li>Tier 2 encompasses levels 2–4.</li>
          <li>Tier 3 encompasses levels 5–7.</li>
          <li>Tier 4 encompasses levels 8–10.</li>
        </ul>
      </p>

      <p>Your tier affects your damage thresholds, tier achievements,
        and access to advancements.</p>

      <h3 id="tier-achievements">STEP ONE: TIER ACHIEVEMENTS</h3>
      <p>Take any applicable tier achievements and access to advancements.</p>
      <ul>
        <li>At level 2, you gain a new Experience at +2 and permanently increase your {PROFICIENCY} by 1.</li>
        <li>At level 5, you gain a new Experience at +2, permanently increase your {PROFICIENCY} by 1, and clear any marked traits.</li>
        <li>At level 8, you gain a new Experience at +2, permanently increase your {PROFICIENCY} by 1, and clear any marked traits.</li>
      </ul>
      <h3 id="step-advancements">STEP TWO: ADVANCEMENTS</h3>
      <p>Choose any two advancements with at least one unmarked slot from your tier or below. Options with multiple slots can be chosen more than once. When you choose an advancement, mark one of its slots.</p>
      <ul>
        <li>When you choose to increase two unmarked character traits and mark them: Choose two unmarked character traits and gain a permanent +1 bonus to them. You can't increase these stats again until the next tier (when your tier achievement allows you to clear those marks).</li>
        <li>When you choose to permanently add 1 or more {HIT_POINTS} slots: Darken the outline of the next rectangle in the {HIT_POINTS} section of your character sheet in pen or permanent marker.</li>
        <li>When you choose to permanently add 1 or more {STRESS} slots: Darken the outline of the next rectangle in the {STRESS} section of your character sheet in pen or permanent marker.</li>
        <li>When you choose to increase your Experience: Choose two Experiences on your character sheet and gain a permanent +1 bonus to both.</li>
        <li>When you take an additional {DOMAIN_CARD}: You can choose an additional {DOMAIN_CARD} at or below your level or from your class's domains. If you've multiclassed, you can instead select a card at or below half your level from your chosen multiclass domain.</li>
        <li>When you choose to increase your {EVASION}: Gain a permanent +1 bonus to your {EVASION}.</li>
        <li>When you choose to take an upgraded subclass card: Take the next card for your subclass. If you have only the foundation card, take a specialization; if you have a specialization already, take a mastery. Then cross out this tier's multiclass option.</li>
        <li>When you choose to increase your {PROFICIENCY}: Fill in one of the open circles in the “{PROFICIENCY}” section of your character sheet, then increase your weapon's number of damage dice by 1. The black box around this advancement's slots indicates you must spend two advancements and mark both level-up slots in order to take it as an option.</li>
        <li>When you choose to multiclass: Choose an additional class, select one of its domains, and gain its class feature. Add the appropriate multiclass module to your character sheet and take the foundation card from one of its subclasses. Then cross out the “upgraded subclass” advancement option in this tier and all other “multiclass” advancement options on your character sheet. The black box around this advancement's slots indicates you must spend two advancements and mark both level-up slots in order to take it as an option.</li>
      </ul>

      <h3 id="step-damage-thresholds">STEP THREE: DAMAGE THRESHOLDS</h3>
      <p>Increase all damage thresholds by 1.</p>

      <h3 id="step-domain-cards">STEP FOUR: DOMAIN CARDS</h3>
      <p>Acquire a new {DOMAIN_CARD} at your level or lower from one of your class's domains and add it to your {LOADOUT} or {VAULT}. If your {LOADOUT} is already full, you can't add the new card to it until you move another into your {VAULT}. You can also exchange one {DOMAIN_CARD} you've previously acquired for a different {DOMAIN_CARD} of the same level or lower.</p>
    </>
  );
}
